export interface RoomVO {
  id: string;
  topic: string;
  active: boolean;
  archived: boolean;
  codOperation: string;
  routerId: string;
  routerDate: string;
  clientUsername: string;
  clientName: string;
  clientHash: string;
  attendantUsername: string;
  attendantName: string;
  attendantHash: string;
  profileUrl?: string;
}

export const emptyRoom = (): RoomVO => ({
  id: '',
  topic: '',
  active: true,
  archived: false,
  codOperation: '',
  routerId: '',
  routerDate: '',
  clientUsername: '',
  clientName: '',
  clientHash: '',
  attendantUsername: '',
  attendantName: '',
  attendantHash: '',
});
